export default __CLIENT__ ? 'ontouchstart' in document.documentElement : false;
